/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdsEventTypesEnum = 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-SUBSCRIPTIONS-REFRESH' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VCF-OAUTH-APP' | 'VMC-OAUTH-APP' | 'RECONFIGURE' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'APPLICATION' | 'RESOURCE-POOL' | 'MONITOR' | 'OAUTH_APP_SECRET_ROTATION' | 'AWS_RESOURCE';

export const VcdsEventTypesEnum = {

    DEPLOYMENT: 'DEPLOYMENT' as VcdsEventTypesEnum,

    SEED_OAUTH_APP: 'SEED-OAUTH-APP' as VcdsEventTypesEnum,

    SUBSCRIPTION: 'SUBSCRIPTION' as VcdsEventTypesEnum,

    RANSOMWARE_RECOVERY: 'RANSOMWARE-RECOVERY' as VcdsEventTypesEnum,

    RELEASE: 'RELEASE' as VcdsEventTypesEnum,

    MAINTENANCE: 'MAINTENANCE' as VcdsEventTypesEnum,

    ACCESS: 'ACCESS' as VcdsEventTypesEnum,

    MIGRATE: 'MIGRATE' as VcdsEventTypesEnum,

    RELEASE_CAPABILITY: 'RELEASE-CAPABILITY' as VcdsEventTypesEnum,

    BILLING_SUBSCRIPTIONS_REFRESH: 'BILLING-SUBSCRIPTIONS-REFRESH' as VcdsEventTypesEnum,

    BILLING_PIPELINE_REFRESH: 'BILLING-PIPELINE-REFRESH' as VcdsEventTypesEnum,

    DATASTORE: 'DATASTORE' as VcdsEventTypesEnum,

    CLOUD_PAIRING: 'CLOUD-PAIRING' as VcdsEventTypesEnum,

    VCF_OAUTH_APP: 'VCF-OAUTH-APP' as VcdsEventTypesEnum,

    VMC_OAUTH_APP: 'VMC-OAUTH-APP' as VcdsEventTypesEnum,

    RECONFIGURE: 'RECONFIGURE' as VcdsEventTypesEnum,

    VMC_POOL: 'VMC-POOL' as VcdsEventTypesEnum,

    DISCONNECTED_DEPLOYMENT: 'DISCONNECTED-DEPLOYMENT' as VcdsEventTypesEnum,

    APPLICATION: 'APPLICATION' as VcdsEventTypesEnum,

    RESOURCE_POOL: 'RESOURCE-POOL' as VcdsEventTypesEnum,

    MONITOR: 'MONITOR' as VcdsEventTypesEnum,

    OAUTH_APP_SECRET_ROTATION: 'OAUTH_APP_SECRET_ROTATION' as VcdsEventTypesEnum,

    AWS_RESOURCE: 'AWS_RESOURCE' as VcdsEventTypesEnum
};

